var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconAlarm04 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#777",
  d: "M3.72 6.78a4.28 4.28 0 1 1 8.561 0v3.671l1.282 2.466H2.447L3.72 10.41z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#777",
  fillRule: "evenodd",
  d: "M9.1 14.568H6.9V13.5h2.2z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#777",
  d: "m1.867 6.1 1.066-.013v-.374c0-1.286.76-2.386 1.854-2.9l-.547-.926a4.28 4.28 0 0 0-2.373 3.826zM11.68 1.807l-.547.926a3.205 3.205 0 0 1 2.014 2.974v.373l1.066.013v-.386A4.29 4.29 0 0 0 11.687 1.8z"
})));
export default SvgIconAlarm04;